<template lang="pug">
    .container-restricao
        div(
            v-if='restricoes.length > 0',
            :class='restricoes[index].inibido ? "camada-inibida" : ""',
            v-for='(restricao, index) in listaRestricoes'
        )
            slot(name='botaoInibir', :restricao='restricoes[index]')
            .card-restricao
                .container-restricao-acoes(
                    v-if='habilitarZoomRestricao && (restricoes[index].geometry || restricoes[index].geometria || geometria)'
                )
                    div
                        el-button(
                            size='small',
                            icon='mdi mdi-crosshairs-gps',
                            @click='aplicarZoomRestricao(index)'
                        )
                slot(name='selecionarRestricao', :restricao='restricoes[index]')
                p
                    b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.uid') }}:
                    |
                    | {{ restricao.uid || '-' }}
                    br
                    b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.ano') }}:
                    |
                    | {{ restricao.ano || '-' }}
                    br
                    b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.classe') }}:
                    |
                    | {{ restricao.classe || '-' }}
                    br
                    b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.dataImgAntiga') }}:
                    |
                    | {{ restricao.data_img_antiga || '-' }}
                    br
                    b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.nomeImgAntiga') }}:
                    |
                    | {{ restricao.nome_img_antiga || '-' }}
                    br
                    b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.dataImgAtual') }}:
                    |
                    | {{ restricao.data_img_atual || '-' }}
                    br
                    b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.nomeImgAtual') }}:
                    |
                    | {{ restricao.nome_img_atual || '-' }}
                    br
                    b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.sigla') }}:
                    |
                    | {{ restricao.sigla || '-' }}
                    br
                    b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.areaHa') }}:
                    |
                    | {{ formatNumber(restricao.areaHa) }}
                    br
                    b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.id') }}:
                    |
                    | {{ restricao.id || '-' }}
                    br
                    Criticidade(
                        v-if='restricao.nivelAlerta'
                        :restricao='restricao'
                    )
    </template>

<script>
import formatters from '@/utils/formatters';
import Criticidade from '@/components/diagnosticoSocioambiental/Criticidade.vue';

export default {
    name: 'desmatamento-vega-2025-com-soja-2425-vega-paraguai',

    data() {
        return {};
    },

    components: {
        Criticidade
    },

    computed: {
        listaRestricoes: function () {
            return this.restricoes.map(value => {
                if (value.properties) {
                    return {
                        ...value.properties
                    };
                }
                return value;
            });
        }
    },

    methods: {
        aplicarZoomRestricao(index) {
            let geometriaQueNaoEstavaDentroDasRestricoes = null;
            if (this.geometria) {
                geometriaQueNaoEstavaDentroDasRestricoes =
                    this.geometria[index];
            }
            this.$emit(
                'aplicar-zoom-restricao',
                this.restricoes[index],
                geometriaQueNaoEstavaDentroDasRestricoes
            );
        },
        formatNumber(number) {
            if (!number) return '-';
            return formatters.maxFormatNumber(number, 2);
        }
    },

    props: {
        restricoes: {
            type: Array,
            required: true
        },
        geometria: {
            type: Array,
            required: false,
            default: null
        },
        habilitarZoomRestricao: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
</script>
